/* wow-reco.js - Phase 1 close-Clerk-gaps (16 Oct 2026). One small deferred module, no third-party code.
   - stable bucket per browser: fnv1a(lucy_browser_id) % 100; 0-9 = holdout (sees none of the Phase 1 rescue/picks)
   - search + reco events -> sendBeacon -> ai-api.wowstore.live/api/crosssell/reco-event (table wow_reco_events), GA4 mirror
   - zero results / 404 rescue: Ask Lucy (query prefilled) + 4 Lucy's picks (active, in stock, margin >= 18 %, re-checked live)
   - _wow_src line-item property on the PDP after a pick click (surface:logic:variant)
   Rollback: docs/reports/2026-10-16-phase1-clerk/rollback.sh */
(function () {
  'use strict';
  if (window.WowReco) return;
  var W = window, d = document, EP = 'https://ai-api.wowstore.live/api/crosssell/';
  function ls(k, v) { try { if (v === undefined) return localStorage.getItem(k); localStorage.setItem(k, v); } catch (e) { return null; } }
  function ss(k, v) { try { if (v === undefined) return sessionStorage.getItem(k); sessionStorage.setItem(k, v); } catch (e) { return null; } }
  function fnv(s) { var h = 2166136261; for (var i = 0; i < s.length; i++) { h ^= s.charCodeAt(i); h = Math.imul(h, 16777619); } return h >>> 0; }
  var B = ls('lucy_browser_id');
  if (!B) { B = 'b' + Date.now() + Math.random().toString(36).slice(2, 8); ls('lucy_browser_id', B); }
  var V = fnv(B) % 100 < 10 ? 'holdout' : 'treatment';
  var SID = ss('wow_sid'); if (!SID) { SID = Math.random().toString(36).slice(2, 12); ss('wow_sid', SID); }
  var LOC = (d.documentElement.lang || 'en').slice(0, 2).toLowerCase(), NL = LOC === 'nl';
  var ROOT = (W.Shopify && W.Shopify.routes && W.Shopify.routes.root) || '/';
  var T = NL ? { picks: "Lucy's keuzes", ask: 'Vraag het Lucy', askSub: 'Lucy zoekt met je mee.', msg: 'Ik zoek: ', meant: 'Bedoelde je…' }
             : { picks: "Lucy's picks", ask: 'Ask Lucy', askSub: 'Lucy helps you find it.', msg: "I'm looking for: ", meant: 'Were you looking for…' };

  /* ---------- events ---------- */
  var Q = [], timer = null, seen = {};
  function flush() {
    timer = null; if (!Q.length) return;
    var body = JSON.stringify({ bid: B, sid: SID, v: V, loc: LOC, pg: location.pathname.slice(0, 160), events: Q.splice(0, 30) });
    try { if (!(navigator.sendBeacon && navigator.sendBeacon(EP + 'reco-event', body))) fetch(EP + 'reco-event', { method: 'POST', body: body, keepalive: true, mode: 'no-cors' }); } catch (e) {}
  }
  function track(e, o) { if (navigator.webdriver) return; o = o || {}; o.e = e; Q.push(o); if (!timer) timer = setTimeout(flush, 700); }
  W.addEventListener('pagehide', flush);
  function ga(n, p) { try { if (typeof W.gtag === 'function') W.gtag('event', n, p); } catch (e) {} }

  function searched(q, n, surface, logic) {
    q = (q || '').trim(); if (!q) return;
    var k = surface + '|' + q.toLowerCase(); if (seen[k]) return; seen[k] = 1;
    track('search_submitted', { s: surface, l: logic, q: q, n: n });
    if (!n) track('search_zero', { s: surface, l: logic, q: q });
    ga('search', { search_term: q });
    if (surface === 'search_page') ga('view_search_results', { search_term: q });
  }
  function resultClick(q, h, pos, surface) { track('search_result_click', { s: surface, q: q, h: h, p: pos }); }

  /* ---------- UI ---------- */
  function css() {
    if (d.getElementById('wr-css')) return;
    var st = d.createElement('style'); st.id = 'wr-css';
    st.textContent = '.wr{margin:20px auto 0;max-width:960px;padding:0 16px;text-align:center}.wr-ask{display:inline-flex;align-items:center;gap:8px;border:0;border-radius:999px;padding:12px 22px;background:#1a1a2e;color:#fff;font:600 14px/1.2 inherit;cursor:pointer}' +
      '.wr-sub{color:#6b7280;font-size:13px;margin:8px 0 0}.wr-h{font-size:16px;font-weight:600;margin:24px 0 12px}.wr-g{display:grid;grid-template-columns:repeat(4,minmax(0,1fr));gap:12px;min-height:160px}' +
      '.wr-c{display:block;text-decoration:none;color:inherit;text-align:left}.wr-c img{width:100%;aspect-ratio:3/4;object-fit:cover;border-radius:8px;background:#f3f4f6}.wr-c span{display:block;font-size:13px;line-height:1.3;margin-top:6px}' +
      '.wr-m{list-style:none;padding:0;margin:8px 0 0}.wr-m a{display:inline-block;padding:6px 0;text-decoration:underline}@media(max-width:600px){.wr-g{grid-template-columns:repeat(2,minmax(0,1fr))}}';
    d.head.appendChild(st);
  }
  function mk(tag, cls, txt) { var e = d.createElement(tag); if (cls) e.className = cls; if (txt) e.textContent = txt; return e; }
  function img(u, w) { if (!u) return ''; u = u.indexOf('//') === 0 ? 'https:' + u : u; return u + (u.indexOf('?') < 0 ? '?' : '&') + 'width=' + w; }

  function askLucy(q, surface) {
    track('ask_lucy', { s: surface, q: q });
    if (W.WowSearch) try { W.WowSearch.close(); } catch (e) {}
    var open = W.LucyAI && W.LucyAI.openChat;
    if (open) W.LucyAI.openChat(); else { var t = d.getElementById('aiChatToggle'); if (t) t.click(); }
    setTimeout(function () { var i = d.getElementById('aiChatInput'); if (i) { i.value = q ? T.msg + q : ''; try { i.focus(); } catch (e) {} } }, 400);
  }

  function observe(el, fn) {
    if (!('IntersectionObserver' in W)) return fn();
    var io = new IntersectionObserver(function (es) { if (es[0].isIntersecting) { io.disconnect(); fn(); } }, { threshold: 0.3 });
    io.observe(el);
  }

  function picks(box, surface, exclude) {
    var logic = 'lucy_picks', g = mk('div', 'wr-g'); box.appendChild(mk('div', 'wr-h', T.picks)); box.appendChild(g);
    fetch(EP + 'lucy-picks?n=8&seed=' + (fnv(B + surface) % 997) + (exclude ? '&exclude=' + encodeURIComponent(exclude) : ''))
      .then(function (r) { return r.json(); })
      .then(function (j) {
        return Promise.all((j.items || []).map(function (it) {   /* serve-time truth: live storefront, available, locale title */
          return fetch(ROOT + 'products/' + it.handle + '.js').then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; });
        }));
      })
      .then(function (ps) {
        ps = ps.filter(function (p) { return p && p.available; }).slice(0, 4);
        if (!ps.length) { box.removeChild(g.previousSibling); box.removeChild(g); return; }
        ps.forEach(function (p, i) {
          var a = mk('a', 'wr-c'); a.href = ROOT + 'products/' + p.handle;
          var im = mk('img'); im.src = img(p.featured_image, 360); im.alt = p.title; im.loading = 'lazy'; im.width = 360; im.height = 480;
          a.appendChild(im); a.appendChild(mk('span', '', p.title));
          a.addEventListener('click', function () {
            track('reco_click', { s: surface, l: logic, h: p.handle, p: i + 1 });
            ss('wow_src_pending', JSON.stringify({ h: p.handle, src: surface + ':' + logic + ':' + V, t: Date.now() }));
          });
          g.appendChild(a);
        });
        observe(g, function () { ps.forEach(function (p, i) { track('reco_impression', { s: surface, l: logic, h: p.handle, p: i + 1 }); }); });
      })
      .catch(function () { if (g.parentNode) { box.removeChild(g.previousSibling); box.removeChild(g); } });
  }

  /* zero-result / 404 rescue. Holdout: nothing new is shown, only the view is logged (for the comparison). */
  function rescue(host, surface, q, exclude) {
    var sv = 'sv|' + surface + '|' + q; if (!seen[sv]) { seen[sv] = 1; track('surface_view', { s: surface, l: 'rescue', q: q }); }
    if (V === 'holdout' || !host) return;
    css();
    var box = mk('div', 'wr'); box.setAttribute('data-wow-picks', surface);
    var b = mk('button', 'wr-ask', T.ask); b.type = 'button';
    b.addEventListener('click', function () { askLucy(q, surface); });
    box.appendChild(b); box.appendChild(mk('p', 'wr-sub', T.askSub));
    host.appendChild(box);
    picks(box, surface, exclude);
    return box;
  }

  /* 404: words from the dead handle -> Shopify predictive -> "Were you looking for…" */
  function meant(host, words) {
    if (V === 'holdout' || !host || !words.length) return;
    var tries = [words.slice(0, 3), words.slice(0, 2), words.slice(-1)];
    (function next(k) {
      if (k >= tries.length) return;
      var q = tries[k].join(' ');
      fetch(ROOT + 'search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=4&resources[options][unavailable_products]=hide')
        .then(function (r) { return r.json(); })
        .then(function (j) {
          var ps = (j.resources && j.resources.results && j.resources.results.products) || [];
          if (!ps.length) return next(k + 1);
          css(); var w = mk('div', 'wr'); w.style.marginTop = '0'; w.appendChild(mk('div', 'wr-h', T.meant)); var ul = mk('ul', 'wr-m');
          ps.forEach(function (p, i) {
            var li = mk('li'), a = mk('a', '', p.title); a.href = p.url;
            a.addEventListener('click', function () { track('reco_click', { s: '404_meant', l: 'shopify_predictive', h: p.handle, p: i + 1, q: q }); });
            li.appendChild(a); ul.appendChild(li);
          });
          w.appendChild(ul); (host.querySelector('.wr-meant-slot') || host).appendChild(w);
          ps.forEach(function (p, i) { track('reco_impression', { s: '404_meant', l: 'shopify_predictive', h: p.handle, p: i + 1, q: q }); });
        }).catch(function () {});
    })(0);
  }

  /* PDP: carry the pick source onto the add-to-cart as a hidden line-item property (main + sticky form only) */
  function stampPdp() {
    var raw = ss('wow_src_pending'); if (!raw) return;
    try { raw = JSON.parse(raw); } catch (e) { return; }
    if (!raw || Date.now() - raw.t > 1800000 || location.pathname.split('/products/')[1] !== raw.h) return;
    var fs = d.querySelectorAll('form[action$="/cart/add"][id*="__main"]');
    for (var i = 0; i < fs.length; i++) {
      if (fs[i].querySelector('input[name="properties[_wow_src]"]')) continue;
      var x = d.createElement('input'); x.type = 'hidden'; x.name = 'properties[_wow_src]'; x.value = raw.src; fs[i].appendChild(x);
    }
  }

  /* page hooks: <div id="wow-rescue" data-mode="search|404" data-q=".." data-n=".."> rendered by sections/wow-rescue.liquid */
  function init() {
    stampPdp();
    var r = d.getElementById('wow-rescue'); if (!r) return;
    var mode = r.getAttribute('data-mode'), q = r.getAttribute('data-q') || '', n = parseInt(r.getAttribute('data-n') || '0', 10);
    if (mode === 'search' && q) {
      searched(q, n, 'search_page', 'shopify_search');
      var main = d.querySelector('main') || d.body;
      main.addEventListener('click', function (e) {
        var a = e.target.closest && e.target.closest('a[href*="/products/"]'); if (!a || a.closest('[data-wow-picks]')) return;
        var h = a.pathname.split('/products/')[1] || ''; var order = [], ls_ = main.querySelectorAll('a[href*="/products/"]');
        for (var i = 0; i < ls_.length; i++) { if (ls_[i].closest('[data-wow-picks]')) continue; var hh = ls_[i].pathname.split('/products/')[1]; if (order.indexOf(hh) < 0) order.push(hh); }
        var sp = /[?&]_pos=(\d+)/.exec(a.search); resultClick(q, h, sp ? +sp[1] : order.indexOf(h) + 1, 'search_page');   /* Shopify's own result position first */
      }, true);
      if (!n) rescue(r, 'search_zero', q);
    } else if (mode === '404') {
      var seg = decodeURIComponent(location.pathname.split('/').filter(Boolean).pop() || '');
      var stop = /^(and|with|for|the|met|en|voor|de|het|een|model|\d+|[a-z0-9]{1,2})$/i;
      var words = seg.split(/[-_\s.]+/).filter(function (w) { return w && !stop.test(w); });
      rescue(r, '404', words.join(' '), '');
      meant(r, words);
    }
  }

  W.WowReco = { variant: V, track: track, searched: searched, resultClick: resultClick, rescue: rescue, askLucy: askLucy };
  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', init); else init();
})();
